import * as React from "react";
import {
  Box,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Button,
  SelectChangeEvent,
} from "@mui/material";
import { Project } from "../types/projectTypes";
import DatePicker from "react-datepicker";

interface MonthlySummaryFormProps {
  projects: Project[];
  selectedProject: number | undefined;
  selectedDate: Date | null;
  /** Días del mes en curso hasta la fecha elegida, para resaltar el periodo en el calendario. */
  highlightedDates: Date[];
  stage: string;
  activity: string;
  uniqueSections: (string | undefined)[];
  uniqueActivities: (string | undefined)[];
  isSelectedStage: boolean;
  handleProject: (event: SelectChangeEvent<number>) => void;
  handleDateChange: (date: Date | null) => void;
  handleStage: (event: SelectChangeEvent<string>) => void;
  handleActivity: (event: SelectChangeEvent<string>) => void;
  onClickFilter: VoidFunction;
}

const MonthlySummaryForm: React.FC<MonthlySummaryFormProps> = ({
  projects,
  selectedProject,
  selectedDate,
  stage,
  activity,
  highlightedDates,
  uniqueSections,
  uniqueActivities,
  isSelectedStage,
  handleProject,
  handleDateChange,
  handleStage,
  handleActivity,
  onClickFilter,
}) => {
  // El informe acumula "hasta la fecha", así que no tiene sentido elegir un día futuro:
  // el calendario directamente no lo ofrece. El backend lo valida igual.
  const today = new Date();

  return (
    <Grid container spacing={2} alignItems="center">
      <Grid item xs={12} md={2.5}>
        <FormControl fullWidth>
          <InputLabel>Proyecto</InputLabel>
          <Select
            label="Proyecto"
            name="project"
            value={selectedProject}
            onChange={handleProject}
          >
            {projects.map((project) => (
              <MenuItem key={project.id} value={project.id}>
                Id: {project.id} - {project.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12} md={2.5}>
        <DatePicker
          selected={selectedDate}
          name="dateTable"
          onChange={handleDateChange}
          maxDate={today}
          highlightDates={[
            { "react-datepicker__day--highlighted": highlightedDates },
          ]}
          locale="es"
          calendarStartDay={1}
          popperClassName="custom-datepicker-popper"
          customInput={
            <TextField label="Fecha de corte" variant="outlined" fullWidth />
          }
        />
      </Grid>
      {selectedProject !== 0 && (
        <Grid item xs={12} md={2.5}>
          <FormControl fullWidth>
            <InputLabel>Etapa</InputLabel>
            <Select
              label="Etapa"
              name="stage"
              value={stage}
              onChange={handleStage}
            >
              <MenuItem key="all" value="Todas">
                Todas
              </MenuItem>
              {uniqueSections.map((section, index) => (
                <MenuItem key={index} value={section}>
                  {section}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      )}
      {isSelectedStage && (
        <Grid item xs={12} md={2.5}>
          <FormControl fullWidth>
            <InputLabel>Actividad</InputLabel>
            <Select
              label="Actividad"
              name="activity"
              value={activity}
              onChange={handleActivity}
            >
              <MenuItem key="all" value="Todas">
                Todas
              </MenuItem>
              {uniqueActivities.map((activityName, index) => (
                <MenuItem key={index} value={activityName}>
                  {activityName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      )}
      <Grid item xs={12} md={2}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            height: "100%",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            onClick={onClickFilter}
            sx={{ height: "55px", width: "100%" }}
          >
            Filtrar
          </Button>
        </Box>
      </Grid>
    </Grid>
  );
};

export default MonthlySummaryForm;
